import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { LocalStorageService } from './local-storage.service';
import { UtilsService } from './utils.service';

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    constructor(
        private _router: Router,
        private _http: HttpClient,
        private _utilsService: UtilsService,
        private _localStorageService: LocalStorageService,
    ) { }

    private formatErrors(error: any) {
        if (error && error.error) {
            if (error.status === 401) {
                this._localStorageService.clearAll();
                this._router.navigate(['/']);
                return throwError(error.error.message);
            }
            if (error.error.errors && error.error.errors.length) {
                if (error.error.errors) {
                    return throwError(error.error.errors);
                }
                if (error.error.message.ERR) {
                    return throwError(error.error.message.ERR);
                }
                else {
                    return throwError(error.error.message);
                }
            }
            return throwError(error.error.message);
        }
        return throwError('Something went wrong');
    }

    get(path: string, body: Object = {}, flag?): Observable<any> {
        const url = path;
        let params = new HttpParams();

        if (body && Object.keys(body).length) {
            for (const key in body) {
                if (body.hasOwnProperty(key) && body[key]) {
                    if (Array.isArray(body[key])) {
                        for (let i = 0, len = body[key].length; i < len; i++) {
                            params = params.append(`${key}[]`, body[key][i]);
                        }
                    } else {
                        params = params.set(key, body[key]);
                    }
                }
            }
        }
        let responseType;

        if (flag)
            responseType = 'response';
        else
            responseType = 'body';

        return this._http
            .get(url, { params, observe: responseType })
            .pipe(
                // map(res => this.toastrMessage(res)),
                map(res => res),
                catchError(this.formatErrors.bind(this))
            );
    }

    put(path: string, body: Object = {},flag?): Observable<any> {
        const url = path;
        let responseType;
        if (flag)
            responseType = 'response';
        else
            responseType = 'body';
        return this._http
            .put(url, body, {observe: responseType})
            .pipe(
                // map(res => this.toastrMessage(res)),
                map(res => res),
                catchError(this.formatErrors.bind(this))
            );
    }

    patch(path: string, body: Object = {}): Observable<any> {
        const url = path;
        return this._http
            .patch(url, body)
            .pipe(
                // map(res => this.toastrMessage(res)),
                map(res => res),
                catchError(this.formatErrors.bind(this))
            );
    }

    post(path: string, body: Object = {}, isContentJson?, showProgress?): Observable<any> {
        const url = path;
        return this._http
            .post(url,
                body,
                showProgress ? showProgress : (isContentJson ? { headers: this.setContentTypeJson() } : {}),
            )
            .pipe(
                // map(res => this.toastrMessage(res)),
                map(res => res),
                catchError(this.formatErrors.bind(this))
            );
    }

    delete(path, body: Object = {}): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: body
        };
        const url = path;
        return this._http
            .delete(url, httpOptions)
            .pipe(
                // map(res => this.toastrMessage(res)),
                map(res => res),
                catchError(this.formatErrors.bind(this))
            );
    }

    toastrMessage(data) {
        const transformedData = this._utilsService.transformToCamelCase(data);
        if (transformedData.success && transformedData.hasOwnProperty('message') &&
            transformedData.message && transformedData.message.length) {
        }
        return transformedData;
    }

    mulitipartForm(path: string, formData: FormData, isContentJson?): Observable<any> {
        return this._http.post(
            path,
            formData,
            isContentJson ? { headers: this.setContentTypeFormEncoded() } : {}
        ).pipe(catchError(this.formatErrors));
    }

    mulitipartFormPut(path: string, formData: FormData, isContentJson?): Observable<any> {
        return this._http.put(
            path,
            formData,
            isContentJson ? { headers: this.setContentTypeFormEncoded() } : {}
        ).pipe(catchError(this.formatErrors));
    }

    setContentTypeJson() {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });
        return headers;
    }

    setContentTypeFormEncoded() {
        const headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        return headers;
    }
}




